import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-foreground-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:px-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-heading text-xl font-bold">桃子视频</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
            桃子视频是多元化的高清视频内容平台，汇聚电影、电视剧、综艺等丰富影视资源，帮助你轻松浏览、筛选并发现感兴趣的热门视频。本站为内容演示站点，所有播放功能均为展示效果。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-foreground-50">内容分类</h4>
          <ul className="space-y-2 text-sm text-foreground-300">
            <li>
              <Link to="/category/movie" className="transition-colors hover:text-primary-400">
                电影频道
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition-colors hover:text-primary-400">
                电视剧频道
              </Link>
            </li>
            <li>
              <Link to="/category/variety" className="transition-colors hover:text-primary-400">
                综艺频道
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-primary-400">
                搜索视频
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-foreground-50">关于本站</h4>
          <ul className="space-y-2 text-sm text-foreground-300">
            <li>
              <Link to="/about" className="transition-colors hover:text-primary-400">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/" className="transition-colors hover:text-primary-400">
                首页
              </Link>
            </li>
            <li>
              <a href="mailto:support@peach-video.example.com" className="transition-colors hover:text-primary-400">
                意见反馈
              </a>
            </li>
            <li>
              <a href="mailto:business@peach-video.example.com" className="transition-colors hover:text-primary-400">
                商务合作
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900/70">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-foreground-400 md:flex-row md:px-8">
          <p>© 2025 桃子视频 PeachVideo 版权所有 · 本站为前端演示站点</p>
          <p>友情链接：影视资讯 · 高清片库 · 内容合作 · 用户协议 · 隐私政策</p>
        </div>
      </div>
    </footer>
  );
}